const GetBaseBNFString = "GetBaseBNFString"
const GetBaseBNFHash = "GetBaseBNFHash"
const GetBaseBNF = "GetBaseBNF"
const EngineVersion = "EngineVersion"
const GetStreamList = "GetStreamList"
const GetCustomConnectors = "GetCustomConnectors"
const GetSupportedCodePages = "GetSupportedCodePages"
const GetFolderItemsForPath = "GetFolderItemsForPath"
const GetLogicalDriveStrings = "GetLogicalDriveStrings"
const GetDefaultAppFolder = "GetDefaultAppFolder"
const IsValidConnectionString = "IsValidConnectionString"
const GetDatabasesFromConnectionString = "GetDatabasesFromConnectionString"
const GetOleDbProviders = "GetOleDbProviders"
const GetOdbcDsns = "GetOdbcDsns"
const GetFunctions = "GetFunctions"
const GetBNF = "GetBNF"
const CancelReload = "CancelReload"
const ConfigureReload = "ConfigureReload"
const GetAppEntry = "GetAppEntry"
const ProductVersion = "ProductVersion"
const CreateSessionAppFromApp = "CreateSessionAppFromApp"
const CreateSessionApp = "CreateSessionApp"
const OpenDoc = "OpenDoc"
const GetUniqueID = "GetUniqueID"
const IsPersonalMode = "IsPersonalMode"
const PublishApp = "PublishApp"
const ExportApp = "ExportApp"
const CopyApp = "CopyApp"
const ReplaceAppFromID = "ReplaceAppFromID"
const ReloadExtensionList = "ReloadExtensionList"
const ShutdownProcess = "ShutdownProcess"
const CancelRequest = "CancelRequest"
const IsDesktopMode = "IsDesktopMode"
const DeleteApp = "DeleteApp"
const CreateApp = "CreateApp"
const AllowCreateApp = "AllowCreateApp"
const GetActiveDoc = "GetActiveDoc"
const CreateDocEx = "CreateDocEx"
const GetAuthenticatedUser = "GetAuthenticatedUser"
const InteractDone = "InteractDone"
const GetInteract = "GetInteract"
const GetDocList = "GetDocList"
const QTProduct = "QTProduct"
const OSName = "OSName"
const OSVersion = "OSVersion"
const QvVersion = "QvVersion"
const GetProgress = "GetProgress"
const AbortAll = "AbortAll"
const AbortRequest = "AbortRequest"
export { AbortRequest };
export { AbortAll };
export { GetProgress };
export { QvVersion };
export { OSVersion };
export { OSName };
export { QTProduct };
export { GetDocList };
export { GetInteract };
export { InteractDone };
export { GetAuthenticatedUser };
export { CreateDocEx };
export { GetActiveDoc };
export { AllowCreateApp };
export { CreateApp };
export { DeleteApp };
export { IsDesktopMode };
export { CancelRequest };
export { ShutdownProcess };
export { ReloadExtensionList };
export { ReplaceAppFromID };
export { CopyApp };
export { ExportApp };
export { PublishApp };
export { IsPersonalMode };
export { GetUniqueID };
export { OpenDoc };
export { CreateSessionApp };
export { CreateSessionAppFromApp };
export { ProductVersion };
export { GetAppEntry };
export { ConfigureReload };
export { CancelReload };
export { GetBNF };
export { GetFunctions };
export { GetOdbcDsns };
export { GetOleDbProviders };
export { GetDatabasesFromConnectionString };
export { IsValidConnectionString };
export { GetDefaultAppFolder };
export { GetLogicalDriveStrings };
export { GetFolderItemsForPath };
export { GetSupportedCodePages };
export { GetCustomConnectors };
export { GetStreamList };
export { EngineVersion };
export { GetBaseBNF };
export { GetBaseBNFHash };
export { GetBaseBNFString };